import React, { useEffect, useState } from "react";
import { ethers } from "ethers";
import { tokenAddress, mainContractAddress, BSC_TESTNET_CHAIN_ID, tokenABI, mainContractABI,rpcUrls,blockExplorerUrls } from "../components/constant.js";
const UpgradeButton = () => {
  const [isDAppBrowser, setIsDAppBrowser] = useState(false);
  const [walletAddress, setAddress] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [upgraded, setUpgraded] = useState(false);
  const [status, setStatus] = useState("");
  const [tokenBalance, setTokenBalance] = useState(0);

  const connectWallet = async () => {
    if (typeof window.ethereum === "undefined") {
      return alert("MetaMask not installed");
    }
    try {
      const provider = new ethers.BrowserProvider(window.ethereum);
      const signer = await provider.getSigner();
      const address = await signer.getAddress();
      setAddress(address);
      setIsDAppBrowser(true);
      const tokenContract = new ethers.Contract(tokenAddress, tokenABI, signer);
      let tokenBalance = await tokenContract.balanceOf(address);


      const mainContract = new ethers.Contract(mainContractAddress, mainContractABI, signer);
      let hifiUser = await mainContract.users(address);
      if (hifiUser[1] == true) {
        console.log('user already upgraded');
        setUpgraded(true)
      } else {
        console.log('show upgrade button')
      }
      console.log(' current user wallet addres ', hifiUser)
      // const bnbBalance = await provider.getBalance(address)
      setTokenBalance(ethers.formatUnits(tokenBalance, 18))
    } catch (err) {
      console.error("Wallet connection failed:", err);
    }
  };
  useEffect(() => {
    connectWallet()

  }, []);


  const approveAndUpgrade = async () => {
    try {
      const currentChainId = await window.ethereum.request({ method: 'eth_chainId' });
      if (currentChainId !== BSC_TESTNET_CHAIN_ID) {
        try {
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: BSC_TESTNET_CHAIN_ID }],
          });
        } catch (switchError) {
          if (switchError.code === 4902) {
            // Chain not added, try to add it
            await window.ethereum.request({
              method: 'wallet_addEthereumChain',
              params: [{
                chainId: BSC_TESTNET_CHAIN_ID,
                chainName: 'Binance Smart Chain',
                nativeCurrency: {
                  name: 'BNB',
                  symbol: 'BNB',
                  decimals: 18,
                },
                rpcUrls: [rpcUrls],
                blockExplorerUrls: [blockExplorerUrls],
              }],
            });
          } else {
            console.error('Failed to switch network', switchError);
            return;
          }
        }
      }

      console.log('loader start')
      setIsLoading(true);
      setStatus("Waiting for approval...");
      const provider = new ethers.BrowserProvider(window.ethereum);
      const signer = await provider.getSigner();
      console.log(' at lint 41', tokenAddress)
      // 1. Approve tokens
      const tokenContract = new ethers.Contract(tokenAddress, tokenABI, signer);
      const decimals = await tokenContract.decimals();


      const amount = '50000000000000000000';//ethers.parseUnits("20", "18");
      console.log(amount, ' decimal is here ', decimals)
      const approveTx = await tokenContract.approve(mainContractAddress, amount);
      setStatus("Approving " + amount + " tokens...");
      await approveTx.wait();
      setStatus("Approval successful!");

      // 2. Call registerOther(user, referrer)
      const mainContract = new ethers.Contract(mainContractAddress, mainContractABI, signer);
      console.log("USDT:", tokenAddress);
      console.log("Contract:", mainContractAddress);
      console.log("Fee:", await mainContract.regFee());

      const registerTx = await mainContract.upgrade(); //
      // const registerTx = await mainContract.registerOther('0xd6977aD7D3cEaE67D0901622d130B2EaD4a7b574', referrerAddress); //
      setStatus("upgrading user...");
      await registerTx.wait();
      alert('Congratutlations upgration Complete')
      setStatus("✅ upgration complete!");
      setUpgraded(true)
      setIsLoading(false);

    } catch (err) {
      console.error(err);
      setStatus("❌ Error: " + (err?.message || "Something went wrong"));
      // setIsLoading(false);

    }
  };
  return (
    <>
      <div className="race-card">
        <div className="race-badge">Upgrade: $50</div>
        <div className="race-title">Upgradation Pool</div>
        <div className="race-desc">
          A classic mid-distance challenge for steady runners.
        </div>


        {/* {!upgraded ? (  <button type="button" onClick={() => {approveAndUpgrade()}} disabled={isLoading} className="view-btn">  Upgrade </button> ) : (<div >Already  Upgrade </div>  )} */}

        {isDAppBrowser ? (
          isLoading ? (
            <div style={{ marginTop: "20px", textAlign: "center" }}>
              <p style={{ color: "white" }}>{status}</p>
              <div className="spinner"></div>
            </div>
          ) : (
            <button
              type="button"
              onClick={approveAndUpgrade}
              disabled={isLoading || upgraded}
              className="view-btn"
            >
              {upgraded ? "Already Upgraded" : "Upgrade"}
            </button>
          )
        ) : (
          <p style={{ color: "red" }}>
            ❌ DApp browser not found. Please install Trust Wallet, SafePal or MetaMask.
          </p>
        )}

      </div>
    </>
  );
};
export default UpgradeButton;